"use strict";

exports.__esModule = true;
exports.default = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = {
  "select": {
    "status": "status",
    "documentType": "documentType",
    "uniqueId": "uniqueId",
    "parentId": "parentId",
    "createdAt": "createdAt",
    "updatedAt": "updatedAt",
    "deletedAt": "deletedAt",
    "title": "title",
    "description": "description",
    "priorityId": "priorityId"
  },

  prepare({
    formData
  }) {
    const content = formData.content;
    const title = content && content.title || "Uten tittel";
    const priorityId = content && content.priorityId || formData.priorityId;
    return _extends({}, formData, {
      priorityId: priorityId,
      title: title
    });
  }

};
exports.default = _default;
module.exports = exports.default;